import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDocs = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 15,
	viewBox: "0 0 16 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.25 5.18734C9.93934 5.18734 9.6875 5.43918 9.6875 5.74984C9.6875 6.0605 9.93934 6.31234 10.25 6.31234H12.5C12.8107 6.31234 13.0625 6.0605 13.0625 5.74984C13.0625 5.43918 12.8107 5.18734 12.5 5.18734H10.25Z",
			fill: "#33373D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.6875 8.37484C9.6875 8.06418 9.93934 7.81234 10.25 7.81234H12.5C12.8107 7.81234 13.0625 8.06418 13.0625 8.37484C13.0625 8.6855 12.8107 8.93734 12.5 8.93734H10.25C9.93934 8.93734 9.6875 8.6855 9.6875 8.37484Z",
			fill: "#33373D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.25 10.4373C9.93934 10.4373 9.6875 10.6892 9.6875 10.9998C9.6875 11.3105 9.93934 11.5623 10.25 11.5623H12.5C12.8107 11.5623 13.0625 11.3105 13.0625 10.9998C13.0625 10.6892 12.8107 10.4373 12.5 10.4373H10.25Z",
			fill: "#33373D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.81302 0.838227C6.9847 1.18321 7.81114 1.78453 8.2799 2.18734H13.3925C14.569 2.18734 15.5 3.17703 15.5 4.35251V12.3894C15.5 13.5612 14.5724 14.5623 13.3925 14.5623H2.6075C1.44934 14.5623 0.5 13.613 0.5 12.4548V4.22732C0.5 3.06916 1.44934 2.11982 2.6075 2.11982H2.8175V1.90235C2.8175 1.16057 3.42247 0.541347 4.1869 0.567706C4.65658 0.584187 5.21473 0.658107 5.81302 0.838227ZM3.9425 1.90235C3.9425 1.77413 4.04255 1.6884 4.14813 1.69204C4.5329 1.70557 4.9943 1.76647 5.49019 1.91591L5.49378 1.91698C6.38022 2.1777 7.03117 2.617 7.4375 2.94909V12.4785C7.05468 12.1429 6.5657 11.8095 5.95593 11.5594L5.95472 11.5589C5.27268 11.2811 4.62905 11.1902 4.13559 11.1656L4.12794 11.1652C4.03158 11.1617 3.9425 11.0785 3.9425 10.9624V1.90235ZM8.5625 13.4373V3.31234H13.3925C13.9111 3.31234 14.375 3.76113 14.375 4.35251V12.3894C14.375 12.9844 13.9076 13.4373 13.3925 13.4373H8.5625ZM6.8198 13.4373C6.50125 13.1357 6.07658 12.8249 5.52973 12.6006C4.99838 12.3842 4.48852 12.3099 4.08264 12.2893C3.35623 12.2605 2.8175 11.6548 2.8175 10.9624V3.24482H2.6075C2.07066 3.24482 1.625 3.69048 1.625 4.22732V12.4548C1.625 12.9917 2.07066 13.4373 2.6075 13.4373H6.8198Z",
			fill: "#33373D"
		})
	]
});
export { SvgIconDocs as ReactComponent };
